import React from 'react';
import { Tooltip, styled, tooltipClasses } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomTooltip = styled(({
  className,
  ...props
}) => /*#__PURE__*/_jsx(Tooltip, {
  ...props,
  classes: {
    popper: className
  }
}))(({
  customStyle
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: customStyle && customStyle.borderRadius ? customStyle.borderRadius : '0.25rem',
    padding: customStyle && customStyle.padding ? customStyle.padding : '0.5rem 1rem',
    marginTop: customStyle && customStyle.marginTop ? `${customStyle.marginTop} !important` : '0.875rem',
    marginBottom: customStyle && customStyle.marginBottom ? `${customStyle.marginBottom} !important` : '0.875rem',
    backgroundColor: customStyle && customStyle.background ? `${customStyle.background} !important` : 'var(--gray-20)',
    color: 'var(--gray-100)',
    fontSize: customStyle && customStyle.fontSize ? customStyle.fontSize : '0.75rem',
    fontWeight: customStyle && customStyle.fontWeight ? customStyle.fontWeight : 500,
    userSelect: 'none',
    whiteSpace: 'pre-line'
  },
  [`& .${tooltipClasses.tooltip} > span::before`]: {
    backgroundColor: customStyle && customStyle.background ? `${customStyle.background} !important` : 'var(--gray-20)'
  }
}));
const BasicArrowTooltip = ({
  ...props
}) => {
  return /*#__PURE__*/_jsx(CustomTooltip, {
    ...props
  });
};
export default BasicArrowTooltip;